import React, { FC } from "react";

import useAppOrderStatus from "../../../../hooks/manager/useAppOrderStatus";
import coreImg from "../../../../assets/images/Home/img_core.webp";
import loungeImg from "../../../../assets/images/Home/img_lounge.webp";
import gearImg from "../../../../assets/images/Home/img_gear.webp";
import { ReactComponent as ArrowIcon } from "../../../../assets/images/Home/icon_arrow_link.svg";
import common from "../HomePage.module.scss";

import styles from "./LinksSection.module.scss";

type Props = {
  onemenuLogin: () => void;
  dlpLogin: () => void;
  gearLogin: () => void;
};

type AppLinkKey = "lounge" | "core" | "gear";
type AppLinkItem = {
  img: string;
  label: string;
  desc: string;
  loginFunc: () => void;
};

const LinksSection: FC<Props> = ({ onemenuLogin, dlpLogin, gearLogin }) => {
  const { hasOnlyDlpOrder, hasDlpAndG4sBasicOrder } = useAppOrderStatus();
  const linksHeading = `${
    hasOnlyDlpOrder ? "CORE-教材-" : "各サービス"
  }へのリンク`;

  const appLinkItems: Record<AppLinkKey, AppLinkItem> = {
    lounge: {
      img: loungeImg,
      label: "ENAGEED LOUNGE",
      desc: "クラスの状況を可視化するダッシュボード",
      loginFunc: onemenuLogin,
    },
    core: {
      img: coreImg,
      label: "ENAGEED CORE",
      desc: "授業で使用する探究教材",
      loginFunc: dlpLogin,
    },
    gear: {
      img: gearImg,
      label: "ENAGEED GEAR",
      desc: "振り返り機能",
      loginFunc: gearLogin,
    },
  };

  const appLinkKeys = ((): AppLinkKey[] => {
    if (hasOnlyDlpOrder) return ["core"];
    if (hasDlpAndG4sBasicOrder) return ["core", "gear"];
    return ["lounge", "core"];
  })();

  return (
    <section className={common.section}>
      <h2 className={common.h2}>{linksHeading}</h2>
      {appLinkKeys.map(key => (
        <button
          key={key}
          className={styles.box}
          type="button"
          onClick={appLinkItems[key].loginFunc}
        >
          <div className={styles.group}>
            <img
              className={styles.img}
              src={appLinkItems[key].img}
              alt={appLinkItems[key].label}
            />
            <p className={styles.label}>{appLinkItems[key].label}</p>
          </div>
          <div className={styles.group}>
            <p className={styles.desc}>{appLinkItems[key].desc}</p>
            <ArrowIcon className={styles.icon} />
          </div>
        </button>
      ))}
    </section>
  );
};

export default LinksSection;
